import { Footer } from "../../opus2/footer/footer";
import { apiConfig } from "../config/apiConfig";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { Modal } from 'flowbite';
import { replaceLocalLogoLink } from "../util/replaceLocalLogoLink";
import { checkOSFlowPathAndReturnBoolean, getBrandDetailsFromBrandJson, getWeblocationPathGroupWithSiteConfig, modifyAllApplyLocalHref, updateHeaderContent } from "../util/share";
import { reportScreenSize } from "../location-search-map/reportScreenSize";
import { ScreenType } from "../location-search-map/models/ScreenType";
import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { isTestEnvironment } from "../apiCaching/POST-Requests/helperModules/helperFunctions";
import { apiCaching } from "../config/cachingConfig";
import { DisclaimerServiceIdentifier } from "../util/disclaimerService";
import { localizationTagUpadation, setDBAandLocationPin } from "../util/localizationTag";
import { FullAttributeParams } from "../apiCaching/GET-Requests/interface/fullattribute/fullattributeInterface";
import { getMessagesData } from "../util/siteConfig";

export class SetLocalHeader {
    screenType!: ScreenType;
    private isApp = false;
    constructor() {
        this.screenType = reportScreenSize();
        const dbaName : any = document.getElementById('dbaName');

        this.modalOptions()
        // ends

        if(dbaName){
            localStorage.setItem('dbaName', dbaName?.value);
            localizationTagUpadation()
        }
        const webId : any = document.getElementById('weblocationId')
        if(webId){
            localStorage.setItem('weblocationId', webId?.value)
        }

        if (localStorage.getItem('weblocationId')){
            if (!document.getElementById('full_dbaName')) {
                const inpu1 : any = document.createElement('input');
                inpu1.type = 'hidden';
                inpu1.value = localStorage.getItem('dbaName');
                inpu1.id = 'full_dbaName';
                document.body.appendChild(inpu1);
            }
            if (!document.getElementById('local_weblocationId')) {
                const inpu2: any = document.createElement('input');
                inpu2.type = 'hidden';
                inpu2.value = localStorage.getItem('weblocationId');
                inpu2.id = 'local_weblocationId';
                document.body.appendChild(inpu2);
            }
        }
    }

    public async initAsync() {
        try {
            this.isApp = await checkOSFlowPathAndReturnBoolean();
        } catch (error) {
            console.log("Error occurred in checkOSFlowPathAndReturnBoolean function: " + error);
        }
        this.setHeader();
        // Modify All Apply Locally hrefs
        modifyAllApplyLocalHref();
    }

    public modalOptions() {
        const options: any = {
            placement: 'center',
            backdrop: 'static',
            backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40',
            closable: true,
            onHide: () => {
            },
            onShow: () => {
            },
            onToggle: () => {
            }
          };

          const targetElement = document.getElementById("glb-find-local");
          const modal = new Modal(targetElement, options);
          return modal;
    }
    public modalToggle() {
        const localHeader = document.querySelector<HTMLElement>('.find-local');
        if (localHeader && !localHeader.dataset.localHeaderBound) {
            localHeader.dataset.localHeaderBound = 'true';
            localHeader.addEventListener("click", (e) => {
                e.preventDefault()
                this.modalOptions().show();
            })
        }
        const closeModalID = document.getElementById("close-local-modal");
        if (closeModalID && !closeModalID.dataset.localCloseBound) {
            closeModalID.dataset.localCloseBound = 'true';
            closeModalID.addEventListener("click", () => {
                this.modalOptions().hide();
                setTimeout(() =>document.querySelector("body > div[modal-backdrop]")?.remove(), 0);
            });
        }
    }
    private setMobileLocalHeader(){
        const mobLocalHeader = document.querySelector('.find-local-mobile');
        const dbaName: string | null = localStorage.getItem('dbaName');
        if(localStorage.getItem('franchiseWebLocationId') && dbaName){
            const newHTML = `
                <svg aria-hidden="true" class="icon"> <use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#map-pin-primary"></use></svg>
                    <div>
                        <span class="local-address">${localStorage.getItem('doingBusinessAs')}</span> Change location
                    </div>
                `;
            if (mobLocalHeader ) {
                mobLocalHeader.innerHTML = newHTML;
            }
            this.setHamburgerMenuDba(newHTML);
            this.setHamburgerSubMenuInnerDba(newHTML);
        }
    }

    // Feature 634665 - MDG/PLG Header with Local Address/Phone Number for Insurance
    // Wires up the "Location Info" trigger / close icon so the panel toggles in place.
    // The Location Finder modal CTA inside the panel relies on Flowbite's native
    // data-modal-target/data-modal-toggle binding, same as the existing "Change Location" button.
    //
    // The trigger is rendered by Crownpeak in "classic" mode by default (data-location-info-mode
    // ="classic") because a visitor who isn't localized yet has no location to show info about -
    // clicking it should behave exactly like the existing national "Find My Local" link and open
    // the Location Finder modal directly. Once localization is confirmed (see
    // upgradeLocationInfoTrigger(), called from populateLocationInfoPanel()), the mode flips to
    // "upgraded" and the same click instead toggles the panel. Deliberately not using Flowbite's
    // native data-modal-target/data-modal-toggle binding for the trigger itself, since it binds
    // once at page init and can't be cleanly re-pointed between "open modal" and "toggle panel"
    // behaviour later - so modal opening in classic mode is done explicitly via modalOptions().show().
    private setupLocationInfoPanel() {
        const trigger = document.querySelector<HTMLElement>('[data-location-info-toggle]');
        if (!trigger) return;

        const panel = document.getElementById(trigger.dataset.locationInfoToggle as string);
        if (!panel) return;

        // Uses a dedicated "location-info-panel--open" class (toggled here) rather than the shared
        // Tailwind "hidden" utility: "hidden" and "location-info-panel" both compile to (0,1,0)
        // specificity selectors, so whichever one lands later in the compiled CSS bundle wins
        // regardless of which class is actually present on the element - which made the panel
        // always render open and the close button appear to do nothing.
        if (!trigger.dataset.locationInfoBound) {
            trigger.dataset.locationInfoBound = 'true';
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                if (trigger.dataset.locationInfoMode !== 'upgraded') {
                    this.modalOptions().show();
                    return;
                }
                const isOpen = panel.classList.toggle('location-info-panel--open');
                trigger.setAttribute('aria-expanded', String(isOpen));
            });
        }

        const closeBtn = panel.querySelector<HTMLElement>('.location-info-close');
        if (closeBtn && !closeBtn.dataset.locationInfoBound) {
            closeBtn.dataset.locationInfoBound = 'true';
            closeBtn.addEventListener('click', () => {
                panel.classList.remove('location-info-panel--open');
                trigger.setAttribute('aria-expanded', 'false');
            });
        }
    }

    // Flips the trigger from its default "classic" (Find My Local / opens modal directly) mode into
    // "upgraded" (Location Info / toggles the panel) mode, once localization is confirmed. Called
    // from populateLocationInfoPanel(), which only ever runs once we know the visitor is localized -
    // either immediately from localStorage persisted by a previous local visit, or after the
    // full-attribute API call resolves on a true local page.
    private upgradeLocationInfoTrigger() {
        const trigger = document.querySelector<HTMLElement>('[data-location-info-toggle]');
        if (!trigger || trigger.dataset.locationInfoMode === 'upgraded') return;
        trigger.dataset.locationInfoMode = 'upgraded';
    }

    // Populates the Location Info panel with the DBA name, address and local listing phone number.
    // The phone number is pulled from the same source (`localPhoneNumber`) used for the header call
    // icon beside the hamburger menu (`.header-wrapper .call-cta` / `.form-call-cta`) - never hard-coded.
    private populateLocationInfoPanel(resp?: any) {
        const panel = document.querySelector<HTMLElement>('.location-info-panel');
        if (!panel) return;

        this.upgradeLocationInfoTrigger();

        const dba = resp?.locationDoingBusinessAs ?? localStorage.getItem('doingBusinessAs');
        const dbaEl = panel.querySelector<HTMLElement>('.location-info-dba');
        if (dbaEl && dba) {
            dbaEl.textContent = dba;
        }

        const address = resp?.address ?? localStorage.getItem('localAddress');
        const address2 = resp?.address2 ?? localStorage.getItem('localAddress2');
        const city = resp?.city ?? localStorage.getItem('localCity');
        const state = resp?.state ?? localStorage.getItem('localState');
        const zip = resp?.zip ?? localStorage.getItem('localZip');
        const addressEl = panel.querySelector<HTMLAnchorElement>('.location-info-address');
        if (addressEl && city && state && zip) {
            const fullAddress = [[address, address2].filter(Boolean).join(', '), `${city}, ${state}, ${zip}`]
                .filter(Boolean)
                .join(' ');
            addressEl.textContent = fullAddress;
            addressEl.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
        }

        const phone = localStorage.getItem('localPhoneNumber');
        const phoneEl = panel.querySelector<HTMLAnchorElement>('.location-info-phone');
        if (phoneEl && phone) {
            const reg = /(\d{0,3})(\d{0,3})(\d{0,4})/;
            const phoneFormat: any = reg.exec(String(phone).replace(/\D/g, ''));
            phoneEl.textContent = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
            phoneEl.href = `tel:${phone}`;
        }
    }

    private async setHeader() {
        
        const mobLocalHeader = document.querySelector('.find-local-mobile');
        const dbaName: string | null | any = localStorage.getItem('dbaName');
        const phoneNumberEle:any = document.querySelector('.header-wrapper .call-cta') || document.querySelector('.header-wrapper .form-call-cta');
        const phoneNumber = localStorage.getItem('localPhoneNumber');
        const locationDoingBusinessAs = localStorage.getItem('doingBusinessAs');

        this.setSubtext();
        this.setMobilePhoneNumber(); // set call us number in mobile view
        this.handleOSCTAVisibility();
        // Feature 634665 - MDG/PLG Header with Local Address/Phone Number for Insurance
        // Must run unconditionally, independent of localization state: a visitor who has never
        // localized (no franchiseWebLocationId in localStorage, and no weblocationId input on a
        // national page) hits neither of the two localization branches below, so without this call
        // the "classic" mode click handler (which opens the Location Finder modal) never gets bound
        // and the trigger would appear completely inert.
        this.setupLocationInfoPanel();
        // modalToggle() also binds the "#close-local-modal" handler that removes the leftover
        // "body > div[modal-backdrop]" element on close - without it bound here too, a visitor who
        // opens the modal via the classic-mode Location Info trigger (above) sees the modal itself
        // close correctly but the backdrop stays stuck on screen, since Flowbite's own close doesn't
        // clean that element up. modalToggle() guards its own bindings, so this is safe to call
        // unconditionally alongside the two existing calls further down.
        this.modalToggle();
        if(locationDoingBusinessAs){
            updateHeaderContent(locationDoingBusinessAs);
        }else if (!dbaName) {
            const visibilityTrue : boolean = true;
            this.customizeBrandHeader(visibilityTrue);
        }

        if (phoneNumberEle && phoneNumber) {
            phoneNumberEle.href = `tel:${phoneNumber}`
            const reg = /(\d{0,3})(\d{0,3})(\d{0,4})/;
            const phoneFormat: any = String(phoneNumber)?.replace(/\D/g, '').match(reg);
            phoneNumberEle.innerHTML = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
            phoneNumberEle.setAttribute('data-title',`(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`);
        }
        if (localStorage.getItem('franchiseWebLocationId') && !this.isApp && dbaName && !window.location.href.toLowerCase().includes(dbaName.toLowerCase())){
             this.modalToggle();
             const newHTML = setDBAandLocationPin();
            if (mobLocalHeader && newHTML) {
                mobLocalHeader.innerHTML = newHTML;
            }

            this.setHamburgerMenuDba(newHTML); 
            this.setHamburgerSubMenuInnerDba(newHTML);   
            this.setupLocationInfoPanel();
            this.populateLocationInfoPanel();

            const MobileLogo = document.querySelector('.mobile-menu-logo .brand-logo-mobile') as HTMLElement;
            if(MobileLogo){
                replaceLocalLogoLink(MobileLogo);
            }
            const MobileInnerLogo = document.querySelector('.sidenav-logo-cta .sidenav-brand-logo') as HTMLElement;
            if(MobileInnerLogo){
                replaceLocalLogoLink(MobileInnerLogo);
            }
            const FooterBrandLogo = document.querySelector('.brand-footer .fb-des-link') as HTMLElement;
            if(FooterBrandLogo){
                replaceLocalLogoLink(FooterBrandLogo);
            }
        }
           
        else {
            const webId: FullAttributeParams = ((document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem("franchiseWebLocationId")) as FullAttributeParams;
            if (webId && typeof webId === 'string' && !this.isApp) {
                const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${webId}`;
                
                cachedAPIWrapper(url)
                    .then(async (resp: any) => {
                        let callTrack: any;
                        resp?.callTrackings.forEach((type: any) => {
                            if (type.callTrackingTypeDescription === "WebsiteTracking") {
                                callTrack = type.callTrackingNumber;
                            }
                        });
                        if (!callTrack) {
                            callTrack = resp?.mainPhoneNumber;
                        }
                        localStorage.setItem("franchiseWebLocationId", resp.franchiseWebLocationId);
                        localStorage.setItem('doingBusinessAs', resp.locationDoingBusinessAs);
                        localStorage.setItem('localPhoneNumber', callTrack);
                        // Feature 634665 - MDG/PLG Header with Local Address/Phone Number for Insurance
                        // Persisted so the Location Info panel can be populated on subsequent page loads
                        // from the same full-attribute response, without re-fetching.
                        localStorage.setItem('localAddress', resp?.address ?? '');
                        localStorage.setItem('localAddress2', resp?.address2 ?? '');
                        localStorage.setItem('localCity', resp?.city ?? '');
                        localStorage.setItem('localState', resp?.state ?? '');
                        localStorage.setItem('localZip', resp?.zip ?? '');
                        let countryCode = getCountryCode();
                        sessionStorage.setItem('countryCode', countryCode);
                        const sAddressParam = sessionStorage.getItem('sAddressParam');
                        DisclaimerServiceIdentifier(sAddressParam);
                        const mobLocalHeader = document.querySelector('.find-local-mobile');
                        const phoneNumberEle: any = document.querySelector('.header-wrapper .call-cta') || document.querySelector('.header-wrapper .form-call-cta');
                        const phoneNumber = localStorage.getItem('localPhoneNumber');
                        const dbaName = document.getElementById("full_dbaName");

                        this.setMobilePhoneNumber(); // set call us number in mobile view

                        if (phoneNumberEle && phoneNumber) {
                            phoneNumberEle.href = `tel:${phoneNumber}`;
                            const reg = /(\d{0,3})(\d{0,3})(\d{0,4})/;
                            const phoneFormat: any = String(phoneNumber)?.replace(/\D/g, '').match(reg);
                            phoneNumberEle.innerHTML = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
                            phoneNumberEle.setAttribute('data-title', `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`);
                        }

                        if (dbaName) {
                            const locationDoingBusinessAs = resp?.locationDoingBusinessAs;
                            updateHeaderContent(locationDoingBusinessAs);
                            const visibilityTrue: boolean = false;

                            this.customizeBrandHeader(visibilityTrue);
                            this.modalToggle();
                        }
                        if (resp?.locationDoingBusinessAs) {
                            const newHTML = setDBAandLocationPin();
                            if (mobLocalHeader) {
                                mobLocalHeader.innerHTML = newHTML;
                            }

                            this.setHamburgerMenuDba(newHTML);
                            this.setHamburgerSubMenuInnerDba(newHTML);
                            this.setupLocationInfoPanel();
                            this.populateLocationInfoPanel(resp);

                        }

                        const ft_footer = await Footer.init();
                        ft_footer?.appendSocialLinks(resp?.franchiseWebLocationLinks);
                        ft_footer?.changeFooterAddress(resp);
                        ft_footer?.setMobileNumber(callTrack);
                        this.handleOSCTAVisibility();
                    }).catch((err) => {
                        console.error("Error initializing footer:", err);
                    });
            }
        }

    }

    private async setSubtext() {
        const subtext = document.querySelector('.enable-disable-subtext-header') as HTMLElement;
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    
        if (!subtext) {
            if( isTestEnvironment()){
                console.log("Subtext class not authored from CP, please add the required class for subtext");
            }
            return;
        }
    
        const isLocalized = this.checkLocalization();
        if (isLocalized) {
            await this.handleLocalizedSubtext(subtext, brandData);
        } else {
            this.handleNationalSubtext(subtext, brandData);
        }
        
    }
    
    private checkLocalization(): boolean {
        const dbaName = localStorage.getItem('dbaName');
        return !!(localStorage.getItem('franchiseWebLocationId') && dbaName);
    }
    
    private async handleLocalizedSubtext(subtext: HTMLElement, brandData: any) {
        const urlSiteConfig = await getWeblocationPathGroupWithSiteConfig();
        if (!urlSiteConfig) return;
    
        try {
            const cachedResponse = await getCachedAPIResponse(urlSiteConfig, apiCaching.SiteConfig, false);
            if (cachedResponse) {
                if (cachedResponse.disable_SubText_Local) {
                    subtext.classList.add('hidden');
                } else {
                    this.updateSubtext(subtext, brandData);
                }
            }
        } catch {
            console.error("Error in fetching site config");
        }
    }
    
    private handleNationalSubtext(subtext: HTMLElement, brandData: any) {
        if (brandData?.disable_SubText_National) {
            subtext.classList.add('hidden');
        } else {
            this.updateSubtext(subtext, brandData);
        }
    }
    
    private updateSubtext(subtext: HTMLElement, brandData: any) {
        subtext.classList.remove('hidden');
        subtext.innerHTML = brandData?.subText_value ?? "";
    }
    
    private handleOSCTAVisibility() {
        const hideOSCTA = localStorage.getItem('siteConfigHideOSCTA');
        const ctaButtons = document.querySelectorAll<HTMLElement>(
            '.header-cta-container>a.primary-btn, .mobile-menu-logo>a.primary-btn.replace-with-click-to-lead-cta.cta-header-component-lead, .header-cta-mobile a.primary-btn.replace-with-click-to-lead-cta.cta-header-component-lead'
        );
        
        const headerPhoneNumbers = document.querySelectorAll<HTMLElement>(
            '.header-wrapper .header-cta-wrap, .header-wrapper .form-call-cta'
        );
        
        const mobilePhoneNumbers = document.querySelectorAll<HTMLElement>('.mob-call-cta');
        
        const footerPhoneNumbers = document.querySelectorAll<HTMLElement>(
            '.fb-des-para'
        );

        const stickyFooter = document.querySelector<HTMLElement>('.sticky-footer.footer-fixed');
        
        const sidenavCta = document.querySelectorAll<HTMLElement>('.slide-block .sidenav-cta');
        
        const headerCtaMobile = document.querySelector<HTMLElement>('.brand-header-mob > .header-cta-mobile');
        
        if (ctaButtons?.length > 0) {
            ctaButtons.forEach((button) => {
                if (hideOSCTA === 'true') {
                    button.style.display = 'none';
                } else {
                    button.style.display = 'flex';
                }
            });
        }
        
        if (headerPhoneNumbers?.length > 0) {
            headerPhoneNumbers.forEach((phone) => {
                if (hideOSCTA === 'true') {
                    phone.style.display = 'none';
                } else {
                    phone.style.display = 'flex';
                }
            });
        }
        
        if (mobilePhoneNumbers?.length > 0) {
            mobilePhoneNumbers.forEach((phone) => {
                if (hideOSCTA === 'true') {
                    phone.style.display = 'none';
                } else {
                    phone.style.display = 'flex';
                }
            });
        }
        
        if (footerPhoneNumbers?.length > 0) {
            footerPhoneNumbers.forEach((phone) => {
                if (hideOSCTA === 'true') {
                    phone.style.display = 'none';
                } else {
                    phone.style.display = 'flex';
                }
            });
        }
        
        if (stickyFooter) {
            if (hideOSCTA === 'true') {
                stickyFooter.style.display = 'none';
            } else {
                stickyFooter.style.display = 'block';
            }
        }
       
        if (sidenavCta?.length > 0) {
            sidenavCta.forEach((cta) => {
                if (hideOSCTA === 'true') {
                    cta.style.display = 'none';
                } else {
                    cta.style.display = 'flex';
                }
            });
        }
        
        if (headerCtaMobile) {
            if (hideOSCTA === 'true') {
                headerCtaMobile.style.display = 'none';
            } else {
                if (this.screenType !== ScreenType.Desktop) {
                    headerCtaMobile.style.display = 'flex';
                } else {
                    headerCtaMobile.style.display = 'none';
                }
            }
        }
    }

    private setMobilePhoneNumber(){

        const phoneNumber = localStorage.getItem('localPhoneNumber');
        const mobileNumberEle:any = document.querySelectorAll('.mob-call-cta');
        
        if (mobileNumberEle && phoneNumber) { 
            mobileNumberEle.forEach((ele : any) => {
                ele.href = `tel:${phoneNumber}`;
            });
        }
    }

    private customizeBrandHeader(visibilityTrue:boolean) {
        const brandHeader = document.querySelector(".brand-header") as HTMLElement;
        const brandLogo = brandHeader?.querySelector(".brand-logo-wrapper") as HTMLElement;
        if (brandLogo) {
            brandLogo.style.display = visibilityTrue &&  this.screenType === ScreenType.Desktop ? "flex" : "none";
        }
    
        const findLocal = brandHeader?.querySelector(".find-local") as HTMLElement;
    
        if(findLocal){
            if( this.screenType === ScreenType.Desktop){
                findLocal.style.display = visibilityTrue ? "flex" : "none";
            }else{
                findLocal.style.display = "flex";
            }
        }
    }
    public setHamburgerMenuDba(newHTML:any):any{

        if(this.screenType !== ScreenType.Desktop){
            const findLocalElement = document.querySelector('.brand-header .find-local');
            if(findLocalElement) {
                findLocalElement.innerHTML = newHTML;       
            }
            return findLocalElement;
        }
    }
    public setHamburgerSubMenuInnerDba(newHTML:any):any{
        if(this.screenType !== ScreenType.Desktop){
            const localDBALevel2 = document.querySelectorAll('.main-nav-warpper .find-local');
            if(localDBALevel2){
                localDBALevel2?.forEach((item:any)=>{
                    item.innerHTML = newHTML;
                })
            }
        }
    }
}

async function initSetLocalHeader(): Promise<void> {
    await getMessagesData();
    const setLocalHeader = new SetLocalHeader();
    await setLocalHeader.initAsync();
}

export function shouldReloadOnHistoryNavigation(eventPersisted: boolean, navigationType?: string): boolean {
    if (!eventPersisted && navigationType !== 'back_forward') return false;

    const dbaName = localStorage.getItem('dbaName');
    const hasLocalInput = document.getElementById('dbaName') || document.getElementById('weblocationId');
    return Boolean(!hasLocalInput && dbaName && !window.location.href.toLowerCase().includes(dbaName.toLowerCase()));
}

document.addEventListener('DOMContentLoaded', initSetLocalHeader);
window.addEventListener('pageshow', (event: PageTransitionEvent) => {
    const navigationEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    const navigationType = navigationEntry?.type;
    if (shouldReloadOnHistoryNavigation(event.persisted, navigationType)) {
        window.location.reload();
        return;
    }
    if (!event.persisted && navigationType !== 'back_forward') return;

    initSetLocalHeader().catch((error) => console.error('Error re-initializing SetLocalHeader:', error));
});
